export default __webpack_public_path__ + "static/media/linkedin_2.d702917f.png";